import React, { useState, useContext, useEffect } from 'react';
import {
  Paper,
  Text,
  QuantaFormik,
  QuantaForm,
  useResponsiveParams,
  MixedGridGroup,
  useQuantaFormikContext,
  Grid,
  QuantaToggle,
  Button,
  NotificationList,
  InputGrid,
  CountAnimation,
} from 'quanta-ui';
import { CALCULATE_PREMIUM, INTERMEDIARY_LIST,FETCH_ROLE } from '../../queries';
import { useQuery } from '@apollo/client';
//import useFetchQuery from './lib/graphql/useFetchQuery';
import { useFetchQuery } from 'quanta-flows';
import { QuantaConfigContext } from 'quanta-flows'; //changed from ConfigContext to QuantaConfigContext
//import { ConfigContext } from 'quanta-flows/modules/layout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCalculator,
  faChevronRight,
  faExclamationCircle,
  faSpinner,
} from '@fortawesome/free-solid-svg-icons';
// import { updateMotorQuote } from '../../_graphql/state';
import { updateMotorQuote } from 'quanta-flows/modules/quote/motor/state';
import { GET_TWO_WHEELER_POLICY_VAR_DETAILS } from '../../queries';
//import ModalViewBreakup from '../../../../../common/view-breakup/two-wheeler/view-breakup';
// import { ModalViewBreakupTW } from 'quanta-flows/modules/common/viewBreakUp';
import ModalViewBreakupTW from '../covers/view-breakup'
// import ModalViewBreakup from '../../../../../../../../../quanta-flows/src/modules/common/view-breakup/two-wheeler/view-breakup';
import { useHistory } from 'react-router-dom';
//import { updateBuyMotorPolicy } from '../../../../new-policy-issuance/two-wheeler/_graphql/state';
import { updateBuyMotorPolicy } from 'quanta-flows/modules/proposal/motor/state';
import moment from 'moment';
//import Parse from '../../../../../../lib/intl/CurrencyFormater';
// Parse is changed to CurrencyFormater
import { CurrencyFormater } from 'quanta-flows';
// import { TransactionComponent } from 'quanta-flows';

export default function CoversForm({
  tenureList,
  riskCovers,
  productCode,
  productName,
  motorQuote,
  lobCode,
  lobName,
  quoteNumber,
  selectedIntermediary,
  fieldUserList,
  characterLimitList,
  modify,
  ...props
}) {
  const history = useHistory();
  let colSpan_for_mobile = 1;
  let colSpan_for_Desktop = 3;
  let repeat = useResponsiveParams({
    for_mobile: colSpan_for_mobile,
    for_desktop: colSpan_for_Desktop,
  });
  let screenSize = useResponsiveParams({
    for_mobile: 'mobile',
    for_desktop: 'desktop',
  });
  const MINOR_THRESHOLD_AGE = 18;
  const Numberlimit =10;
  let vehicleIDV=motorQuote?.totalIDV!=='NaN'&&motorQuote?.totalIDV!==''
  ?motorQuote?.totalIDV
  :motorQuote?.changedIDV;
  let electricalLimit =vehicleIDV*25/100;
  const NumberlimitRS =(electricalLimit-1);
  let emiamountlimit=vehicleIDV*30/100;
  const emi_Limit =(emiamountlimit-1);
 const validate = (values) => {
    let errors = {};
    // if (!values?.tenure) {
    //   errors.tenure = '* Required';
    // }
    errors.addOnCovers = {};
    riskCovers?.forEach((riskCover) => {
      riskCover?.covers?.forEach((cover) => {
        if (values['addOnCovers'][`${cover?.name}`].selected) {
          cover?.attributes
            ?.filter((attribute) => attribute?.showOnScreen)
            ?.forEach((attribute) => {
              if (
                (!values[`addOnCovers`][`${cover?.name}`][
                `attributes`
                ][`${attribute?.name}`])
                 &&attribute?.fieldType!=='checkbox'
                 &&attribute?.displayName!=='Voluntary Deductible for Depreciation'
              ) {
                if (
                  errors[`addOnCovers`][`${cover?.name}`] ===
                  undefined
                ) {
                  errors[`addOnCovers`][`${cover?.name}`] = {
                    attributes: {},
                  };
                }
                if (
                  !(
                    values[`addOnCovers`][`${cover?.name}`][
                    `attributes`
                    ][
                    `${cover?.attributes
                      ?.filter(
                        (attribute) => attribute?.showOnScreen,
                      )
                      ?.find(
                        (attribute) =>
                          attribute?.displayName?.toLowerCase() ===
                          'nominee dob',
                      )?.name
                    }`
                    ] &&
                    moment(new Date(), 'DD/MM/YYYY').diff(
                      moment(
                        values[`addOnCovers`][`${cover?.name}`][
                        `attributes`
                        ][
                        `${cover?.attributes
                          ?.filter(
                            (attribute) =>
                              attribute?.showOnScreen,
                          )
                          ?.find(
                            (attribute) =>
                              attribute?.displayName?.toLowerCase() ===
                              'nominee dob',
                          )?.name
                        }`
                        ],
                        'DD/MM/YYYY',
                      ),
                      'years',
                    ) >= MINOR_THRESHOLD_AGE &&
                    (attribute?.displayName?.toLowerCase() ===
                      'name of appointee' ||
                      attribute?.displayName?.toLowerCase() ===
                      'relationship of appointee')
                  )
                ) {
                  errors[`addOnCovers`][`${cover?.name}`][
                    `attributes`
                  ][`${attribute?.name}`] = '* Required';
                }
              }
              if (
                values[`addOnCovers`][`${cover?.name}`][`attributes`][
                `${cover?.attributes
                  ?.filter((attribute) => attribute?.showOnScreen)
                  ?.find(
                    (attribute) =>
                      attribute?.displayName?.toLowerCase() ===
                      'nominee name',
                  )?.name
                }`
                ] &&
                !isNaN(
                  parseInt(
                    characterLimitList?.find(
                      (characterLimit) =>
                        characterLimit?.code
                          ?.toString()
                          ?.trim()
                          ?.toLowerCase() === 'first name',
                    )?.value,
                  ),
                ) &&
                values[`addOnCovers`][`${cover?.name}`][`attributes`][
                  `${cover?.attributes
                    ?.filter((attribute) => attribute?.showOnScreen)
                    ?.find(
                      (attribute) =>
                        attribute?.displayName?.toLowerCase() ===
                        'nominee name',
                    )?.name
                  }`
                ]?.length >
                parseInt(
                  characterLimitList?.find(
                    (characterLimit) =>
                      characterLimit?.code
                        ?.toString()
                        ?.trim()
                        ?.toLowerCase() === 'first name',
                  )?.value,
                ) &&
                attribute?.displayName?.toString()?.toLowerCase() ===
                'nominee name'
              ) {
                if (
                  errors[`addOnCovers`][`${cover?.name}`] ===
                  undefined
                ) {
                  errors[`addOnCovers`][`${cover?.name}`] = {
                    attributes: {},
                  };
                }
                errors[`addOnCovers`][`${cover?.name}`][`attributes`][
                  `${attribute?.name}`
                ] = `* Nominee name cannot be greater than ${characterLimitList?.find(
                  (characterLimit) =>
                    characterLimit?.code
                      ?.toString()
                      ?.trim()
                      ?.toLowerCase() === 'first name',
                )?.value
                } characters`;
              }
	       if (
                values[`addOnCovers`][`${cover?.name}`][`attributes`][
                `${cover?.attributes
                  ?.filter((attribute) => attribute?.showOnScreen)
                  ?.find(
                    (attribute) =>
                      attribute?.displayName ===
                      'CNG/ LPG KIT(Rs)',
                  )?.name
                }`
                ] &&
                !isNaN(
                  parseInt(
                    Numberlimit,
                  ),
                ) &&
                values[`addOnCovers`][`${cover?.name}`][`attributes`][
                  `${cover?.attributes
                    ?.filter((attribute) => attribute?.showOnScreen)
                    ?.find(
                      (attribute) =>
                        attribute?.displayName ===
                        'CNG/ LPG KIT(Rs)',
                    )?.name
                  }`
                ]?.length >
                parseInt(
                  Numberlimit,
                ) &&
                attribute?.displayName?.toString() ===
                'CNG/ LPG KIT(Rs)'
              ) {
                if (
                  errors[`addOnCovers`][`${cover?.name}`] ===
                  undefined
                ) {
                  errors[`addOnCovers`][`${cover?.name}`] = {
                    attributes: {},
                  };
                }
                errors[`addOnCovers`][`${cover?.name}`][`attributes`][
                  `${attribute?.name}`
                ] = `*Cannot be greater than ${Numberlimit
                } characters`;
              }
              if (
                values[`addOnCovers`][`${cover?.name}`][`attributes`][
                `${cover?.attributes
                  ?.filter((attribute) => attribute?.showOnScreen)
                  ?.find(
                    (attribute) =>
                      attribute?.displayName ===
                      'Tyre Details(Serial No/Make/Year)',
                  )?.name
                }`
                ] &&
                !values[`addOnCovers`][`${cover?.name}`][
                  `attributes`
                ][
                  `${cover?.attributes
                    ?.filter((attribute) => attribute?.showOnScreen)
                    ?.find(
                      (attribute) =>
                        attribute?.displayName ===
                        'Tyre Details(Serial No/Make/Year)',
                    )?.name
                  }`
                ]?.match(/^[a-zA-Z0-9\.\' ]*$/) &&
                attribute?.displayName?.toString() ===
                'Tyre Details(Serial No/Make/Year)'
              ) 
              {
                if (
                  errors[`addOnCovers`][`${cover?.name}`] ===
                  undefined
                ) {
                  errors[`addOnCovers`][`${cover?.name}`] = {
                    attributes: {},
                  };
                }
                errors[`addOnCovers`][`${cover?.name}`][`attributes`][
                  `${attribute?.name}`
                ] = `* Tyre Details can contain alphabets only`;
              }
              if (
                values[`addOnCovers`][`${cover?.name}`][`attributes`][
                `${cover?.attributes
                  ?.filter((attribute) => attribute?.showOnScreen)
                  ?.find(
                    (attribute) =>
                      attribute?.displayName?.toLowerCase() ===
                      'nominee name',
                  )?.name
                }`
                ] &&
                !isNaN(
                  parseInt(
                    characterLimitList?.find(
                      (characterLimit) =>
                        characterLimit?.code
                          ?.toString()
                          ?.trim()
                          ?.toLowerCase() === 'first name',
                    )?.value,
                  ),
                ) &&
                values[`addOnCovers`][`${cover?.name}`][`attributes`][
                  `${cover?.attributes
                    ?.filter((attribute) => attribute?.showOnScreen)
                    ?.find(
                      (attribute) =>
                        attribute?.displayName?.toLowerCase() ===
                        'nominee name',
                    )?.name
                  }`
                ]?.length >
                parseInt(
                  characterLimitList?.find(
                    (characterLimit) =>
                      characterLimit?.code
                        ?.toString()
                        ?.trim()
                        ?.toLowerCase() === 'first name',
                  )?.value,
                ) &&
                attribute?.displayName?.toString()?.toLowerCase() ===
                'nominee name'
              ) {
                if (
                  errors[`addOnCovers`][`${cover?.name}`] ===
                  undefined
                ) {
                  errors[`addOnCovers`][`${cover?.name}`] = {
                    attributes: {},
                  };
                }
                errors[`addOnCovers`][`${cover?.name}`][`attributes`][
                  `${attribute?.name}`
                ] = `* Nominee name cannot be greater than ${characterLimitList?.find(
                  (characterLimit) =>
                    characterLimit?.code
                      ?.toString()
                      ?.trim()
                      ?.toLowerCase() === 'first name',
                )?.value
                } characters`;
              }
              if (
                values[`addOnCovers`][`${cover?.name}`][`attributes`][
                `${cover?.attributes
                  ?.filter((attribute) => attribute?.showOnScreen)
                  ?.find(
                    (attribute) =>
                      attribute?.displayName?.toLowerCase() ===
                      'nominee name',
                  )?.name
                }`
                ] &&
                !values[`addOnCovers`][`${cover?.name}`][
                  `attributes`
                ][
                  `${cover?.attributes
                    ?.filter((attribute) => attribute?.showOnScreen)
                    ?.find(
                      (attribute) =>
                        attribute?.displayName?.toLowerCase() ===
                        'nominee name',
                    )?.name
                  }`
                ]?.match(/^[a-zA-Z ]+$/) &&
                attribute?.displayName?.toString()?.toLowerCase() ===
                'nominee name'
              ) {
                if (
                  errors[`addOnCovers`][`${cover?.name}`] ===
                  undefined
                ) {
                  errors[`addOnCovers`][`${cover?.name}`] = {
                    attributes: {},
                  };
                }
                errors[`addOnCovers`][`${cover?.name}`][`attributes`][
                  `${attribute?.name}`
                ] = `* Nominee name can contain alphabets only`;
              }

              if (
                values[`addOnCovers`][`${cover?.name}`][`attributes`][
                `${cover?.attributes
                  ?.filter((attribute) => attribute?.showOnScreen)
                  ?.find(
                    (attribute) =>
                      attribute?.displayName?.toLowerCase() ===
                      'name of appointee',
                  )?.name
                }`
                ] &&
                !isNaN(
                  parseInt(
                    characterLimitList?.find(
                      (characterLimit) =>
                        characterLimit?.code
                          ?.toString()
                          ?.trim()
                          ?.toLowerCase() === 'first name',
                    )?.value,
                  ),
                ) &&
                values[`addOnCovers`][`${cover?.name}`][`attributes`][
                  `${cover?.attributes
                    ?.filter((attribute) => attribute?.showOnScreen)
                    ?.find(
                      (attribute) =>
                        attribute?.displayName?.toLowerCase() ===
                        'name of appointee',
                    )?.name
                  }`
                ]?.length >
                parseInt(
                  characterLimitList?.find(
                    (characterLimit) =>
                      characterLimit?.code
                        ?.toString()
                        ?.trim()
                        ?.toLowerCase() === 'first name',
                  )?.value,
                ) &&
                attribute?.displayName?.toString()?.toLowerCase() ===
                'name of appointee'
              ) {
                if (
                  errors[`addOnCovers`][`${cover?.name}`] ===
                  undefined
                ) {
                  errors[`addOnCovers`][`${cover?.name}`] = {
                    attributes: {},
                  };
                }
                errors[`addOnCovers`][`${cover?.name}`][`attributes`][
                  `${attribute?.name}`
                ] = `* Appointee name cannot be greater than ${characterLimitList?.find(
                  (characterLimit) =>
                    characterLimit?.code
                      ?.toString()
                      ?.trim()
                      ?.toLowerCase() === 'first name',
                )?.value
                } characters`;
              }

              if (
                values[`addOnCovers`][`${cover?.name}`][`attributes`][
                `${cover?.attributes
                  ?.filter((attribute) => attribute?.showOnScreen)
                  ?.find(
                    (attribute) =>
                      attribute?.displayName?.toLowerCase() ===
                      'name of appointee',
                  )?.name
                }`
                ] &&
                !values[`addOnCovers`][`${cover?.name}`][
                  `attributes`
                ][
                  `${cover?.attributes
                    ?.filter((attribute) => attribute?.showOnScreen)
                    ?.find(
                      (attribute) =>
                        attribute?.displayName?.toLowerCase() ===
                        'name of appointee',
                    )?.name
                  }`
                ]?.match(/^[a-zA-Z ]+$/) &&
                attribute?.displayName?.toString()?.toLowerCase() ===
                'name of appointee'
              ) {
                if (
                  errors[`addOnCovers`][`${cover?.name}`] ===
                  undefined
                ) {
                  errors[`addOnCovers`][`${cover?.name}`] = {
                    attributes: {},
                  };
                }
                errors[`addOnCovers`][`${cover?.name}`][`attributes`][
                  `${attribute?.name}`
                ] = `* Appointee name can contain alphabets only`;
              }
              if(motorQuote?.businessType?.toLowerCase() == 'roll over'){

              if (
                attribute?.fieldType == 'checkbox' &&
                  values[`addOnCovers`][`${cover?.name}`][
                  `attributes`
                ][`${attribute?.name}`]?.toString()==='false'
                
              ) {
                if (
                  errors[`addOnCovers`][`${cover?.name}`] ===
                  undefined
                ) {
                  errors[`addOnCovers`][`${cover?.name}`] = {
                    attributes: {},
                  };
                }
                errors[`addOnCovers`][`${cover?.name}`][`attributes`][
                  `${attribute?.name}`
                ] = '* Required';
              }
            }

              if (
               ( parseFloat( values[`addOnCovers`][`${cover?.name}`][`attributes`][
                   `${cover?.attributes
                     ?.filter((attribute) => attribute?.showOnScreen)
                     ?.find(
                       (attribute) =>
                         attribute?.displayName ===
                         'Non Electrical Accessories(Rs)',
                     )?.name
                   }`
                 ]) > NumberlimitRS)
               ) {
                 if (
                   errors[`addOnCovers`][`${cover?.name}`] ===
                   undefined
                 ) {
                   errors[`addOnCovers`][`${cover?.name}`] = {
                     attributes: {},
                   };
                 }
                 errors[`addOnCovers`][`${cover?.name}`][`attributes`][
                   `${attribute?.name}`
                 ] = `*SI Cannot be greater than 25% of IDV`;
               }
               // Validation for Electrical attributes 
              if (
                parseFloat( values[`addOnCovers`][`${cover?.name}`][`attributes`][
                   `${cover?.attributes
                     ?.filter((attribute) => attribute?.showOnScreen)
                     ?.find(
                       (attribute) =>
                         attribute?.displayName ===
                         'Electrical Accessories(Rs)',
                     )?.name
                   }`
                 ]) > NumberlimitRS
               ) {
                 if (
                   errors[`addOnCovers`][`${cover?.name}`] ===
                   undefined
                 ) {
                   errors[`addOnCovers`][`${cover?.name}`] = {
                     attributes: {},
                   };
                 }
                 errors[`addOnCovers`][`${cover?.name}`][`attributes`][
                   `${attribute?.name}`
                 ] = `*SI Cannot be greater than 25% of IDV`;
               }
              if (
                parseFloat( values[`addOnCovers`][`${cover?.name}`][`attributes`][
                   `${cover?.attributes
                     ?.filter((attribute) => attribute?.showOnScreen)
                     ?.find(
                       (attribute) =>
                         attribute?.displayName ===
                         'EMI Amount',
                     )?.name
                   }`
                 ]) > emi_Limit
               ) {
                 if (
                   errors[`addOnCovers`][`${cover?.name}`] ===
                   undefined
                 ) {
                   errors[`addOnCovers`][`${cover?.name}`] = {
                     attributes: {},
                   };
                 }
                 errors[`addOnCovers`][`${cover?.name}`][`attributes`][
                   `${attribute?.name}`
                 ] = `*EMI Amount Cannot be greater than 30% of IDV`;
               }
              if (
                attribute?.fieldDataType === 'amount' &&
                parseFloat(
                  values[`addOnCovers`][`${cover?.name}`][
                  `attributes`
                  ][`${attribute?.name}`],
                ) <= 0
              ) {
                if (
                  errors[`addOnCovers`][`${cover?.name}`] ===
                  undefined
                ) {
                  errors[`addOnCovers`][`${cover?.name}`] = {
                    attributes: {},
                  };
                }
                errors[`addOnCovers`][`${cover?.name}`][`attributes`][
                  `${attribute?.name}`
                ] = '* Amount should be greater than 0';
              }

              if (
                attribute?.fieldDataType === 'date' &&
                moment(
                  values[`addOnCovers`][`${cover?.name}`][
                  `attributes`
                  ][`${attribute?.name}`],
                  'DD/MM/YYYY',
                ).isAfter(moment(new Date(), 'DD/MM/YYYY'))
              ) {
                if (
                  errors[`addOnCovers`][`${cover?.name}`] ===
                  undefined
                ) {
                  errors[`addOnCovers`][`${cover?.name}`] = {
                    attributes: {},
                  };
                }
                errors[`addOnCovers`][`${cover?.name}`][`attributes`][
                  `${attribute?.name}`
                ] = '* Cannot accept future date';
              }
            });
          if (
            errors[`addOnCovers`][`${cover?.name}`] &&
            errors[`addOnCovers`][`${cover?.name}`][`attributes`] &&
            Object.keys(
              errors[`addOnCovers`][`${cover?.name}`][`attributes`],
            )?.length === 0
          ) {
            delete errors[`addOnCovers`][`${cover?.name}`];
          }
        }
      });
    });
    return errors;
  };

  const CoversDetails = ({ validate }) => {
    const { values, setFieldValue } = useQuantaFormikContext();
    const [
      showCalculatePremiumButton,
      setShowCalculatePremiumButton,
    ] = useState(false);

    const fetchQuery = useFetchQuery();
    const { branding } = useContext(QuantaConfigContext);
    const [premiumData, setPremiumData] = useState(null);
    const [showViewBreakup, setShowViewBreakup] = useState(false);
    const [alerts, setAlerts] = useState([]);
    const [loadingPremium, setLoadingPremium] = useState(false);
    const [proceeding, setProceeding] = useState(false);

    const [resultPremiumError, setResultPremiumError] =
      useState(false);

    const calculatePremiumVariables = (tenure, riskInput,trailerArr,ownerDriverSelected) => {
      return {
        input: {
          productCode
          :motorQuote?.productVariant?.toLowerCase()?.search('comprehensive') !== -1
          ?'3183'
          :motorQuote?.productVariant?.toLowerCase()?.search('liability') !== -1
          ?'3184'
          :"3183",
          productType: motorQuote?.productType,
          customerType:
            motorQuote?.vehicleOwnerTypeAndGender?.organisationType,
          gender: motorQuote?.vehicleOwnerTypeAndGender?.gender,
          businessType: motorQuote?.businessType,
          isTrailerRequired:motorQuote?.isTrailerRequired,
          nooftrailers:motorQuote?.nooftrailers,
          towedby:motorQuote?.towedby,
          totalIDV:motorQuote?.totalIDV,
          bodyIDV:motorQuote?.bodyIDV,
          coverforlamps:motorQuote?.coverforlamps,
          coverforprivateandcommercial:motorQuote?.coverforprivateandcommercial,
          vehicleusedlimitedtoownpremises:motorQuote?.vehicleusedlimitedtoownpremises,
          vehicleuseddrivingtuitions:motorQuote?.vehicleuseddrivingtuitions,
          ImportedVehicle:motorQuote?.ImportedVehicle,
          ConfinedtoOwnPremises:motorQuote?.ConfinedtoOwnPremises,
          SoftCopyDiscount:motorQuote?.SoftCopyDiscount,
          AntiTheftDiscount:motorQuote?.AntiTheftDiscount,
          intermediary: {
            intermediaryCode:
              motorQuote?.intermediaryDetails?.code ||
              selectedIntermediary?.intermediaryCode
            ,
            locationCode:motorQuote?.intermediaryDetails?.location
            ?motorQuote?.intermediaryDetails?.location
             :selectedIntermediary?.branchOfficeCode,
            fieldUserCode:
              motorQuote?.intermediaryDetails?.fieldUserCode ||
              selectedIntermediary?.fieldUserCode
            ,
          },
          tenure,
          rto: {
            rtoAuthCode: motorQuote?.rtoAuthorityCode,
            rtoLocCode: motorQuote?.rtoLocationCode,
            rtoLocDesc: motorQuote?.rtoLocationDesc,
          },
          trailerDetails:trailerArr,
          vehicle: {
            make: motorQuote?.make?.code,
            model: motorQuote?.model?.code,
            variant: motorQuote?.variant?.code,
            engineNumber: motorQuote?.engineNo,
            chasisNumber: motorQuote?.chasisNo,
            registrationNumber: motorQuote?.regNo,
            manufactureYear: motorQuote?.yearOfManufacture,
            regPurchaseDate: motorQuote?.dateOfReg,
            fuelType: motorQuote?.fuelType,
            seatingCapacity: motorQuote?.seatingCapacity,
            cubicCapacity: motorQuote?.cubeCapacity,
            carryingCapacity:motorQuote?.carryingCapacity,
            gvw:motorQuote?.gvw,
            carriageType:motorQuote?.carriageType?.code,
            usageType:motorQuote?.usageType?.code,
            typeofCarriage:motorQuote?.typeofCarriage?.code,
            typeOfBody:motorQuote?.typeOfBody,
            permitType:motorQuote?.permitType?.code,  
            vehicleuse:motorQuote?.vehicleuse?.code,
            vehiclesubType:motorQuote?.vehiclesubType?.code,
            subProduct:motorQuote?.subProduct?.value,
              },
          firstYearIDV: motorQuote?.changedIDV,
          irf1: motorQuote?.adjustmentIRF,
          prevInsurance: {
            coverType:
            motorQuote?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
          'yes'
              // motorQuote?.businessType?.toLowerCase() === 'roll over' ||motorQuote?.businessType?.toLowerCase() === 'used car'
                ? motorQuote?.policyCoverType
                : '',
            policyTenure:
            motorQuote?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
          'yes'
              // motorQuote?.businessType?.toLowerCase() === 'roll over' ||motorQuote?.businessType?.toLowerCase() === 'used car'
                ? motorQuote?.policyTenure
                : '',
            insurerName: motorQuote?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
          'yes'
              // motorQuote?.businessType?.toLowerCase() === 'roll over' ||motorQuote?.businessType?.toLowerCase() === 'used car'
                ? motorQuote?.prevInsurance?.insurerName
                : '',
            policyNumber:
            motorQuote?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
          'yes'
              // motorQuote?.businessType?.toLowerCase() === 'roll over' ||motorQuote?.businessType?.toLowerCase() === 'used car'
                ? motorQuote?.prevInsurance?.policyNumber
                : '',
            startDate:
            motorQuote?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
          'yes'
              // motorQuote?.businessType?.toLowerCase() === 'roll over' ||motorQuote?.businessType?.toLowerCase() === 'used car'
                ? motorQuote?.policyStartDate
                : '',
            expiryDate:
            motorQuote?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
          'yes'
              // motorQuote?.businessType?.toLowerCase() === 'roll over' ||motorQuote?.businessType?.toLowerCase() === 'used car'
                ? motorQuote?.policyExpiryDate
                : '',
            PypPolicyTenureTP: 
            motorQuote?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
          'yes'
            ? motorQuote?.TP_Policy_Tenure
            :'',
            PypStartDateTP:  motorQuote?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
          'yes'
            ? motorQuote?.TP_Start_Date
            :'',
            PypEndDateTP:  motorQuote?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
          'yes'
            ? motorQuote?.TP_End_Date
            :'',
            PypInsurerTP:null,
            TPPolicyNo:null
          },
          prevClaims: {
            totalClaimCount:
            motorQuote?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
            'yes'   
                ? motorQuote?.totalClaimCount
                : '',
            claimsInYear1:
            motorQuote?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
            'yes'          
                ? motorQuote?.noOfClaimsOneYear
                : '',
            claimsInYear2:
              motorQuote?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
          'yes'
                ? motorQuote.noOfClaimsTwoYears
                : '',
            claimsInYear3:
              motorQuote?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
          'yes'
                ? motorQuote.noOfClaimsThreeYears
                : '',
            prevNCBSlab:
             motorQuote?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
          'yes'
                ? motorQuote?.previousYearNCBSlab
                : '',
            totalClaimAmount:
              motorQuote?.anyPreviousPolicyforVehicleTaken?.toLowerCase() ===
          'yes'
                ? parseFloat(motorQuote?.totalClaimAmount)
                : null,
            claimFreeYear: '',
          },
          financerName: motorQuote?.financerName,
          riskCovers: riskInput ? riskInput : [],
          ownerDriverSelected:ownerDriverSelected,
          creditScore: {
            discountOpted:
              motorQuote?.getAdditionalCreditScore?.toLowerCase() ===
                'yes'
                ? true
                : false,
            idProofType: motorQuote?.idProofType,
            idProofNumber: motorQuote?.idProofNumber,
            creditScore: null,
          },
          proposerPincode: motorQuote?.pincode,
          voluntaryDeductibleAmt:
            motorQuote?.voluntaryDeductibleAmount
              ? parseFloat(motorQuote?.voluntaryDeductibleAmount)
              : null,
        },
      };
    };

    useEffect(() => {
      const getCalculatePremium = async () => {
        if (motorQuote?.quotationNo && !modify) {
          setPremiumData({
            calculatePremiumQuotePCV: {
              ...motorQuote?.premiumData,
            },
          });
        } else {
          try {
            setResultPremiumError(false);
            let riskInput = [];
            let ownerDriverSelected='false';
            riskCovers?.forEach((r) => {
              let covers = [];
              r.covers
                .filter(
                  (c) => values[`addOnCovers`][c?.name]?.selected,
                )
                .forEach((c) => {
                  const { selected, attributes, ...rest } = c;
                  let attributesArr = [];
                  c?.attributes?.forEach((attribute) => {
                    attributesArr.push({
                      ...attribute,
                      value: attribute?.showOnScreen
                        ? `${values[`addOnCovers`][`${c?.name}`][
                        `attributes`
                        ][`${attribute?.name}`]
                        }`
                        : `${attribute?.defaultValue}`,
                    });
                  });
                  covers.push({
                    ...rest,
                    attributes: [...attributesArr],
                  });
                });
              if (covers?.length !== 0) {
                riskInput.push({
                  riskType: r?.riskType,
                  covers,
                });
              }
             if (values[`addOnCovers`][`Owner Driver`]?.selected)
             {
              ownerDriverSelected= 'true'
             }
            });
            let  trailerArr = [];
            motorQuote?.trailerDetails?.forEach((_, idx) => {
             trailerArr.push({
                 make: motorQuote?.trailerDetails[idx].make,
                 model: motorQuote?.trailerDetails[idx].model,
                 regnumber: motorQuote?.trailerDetails[idx].regnumber,
                 ChassisNumber: motorQuote?.trailerDetails[idx].ChassisNumber,
                 SI: motorQuote?.trailerDetails[idx].SI,
                 yearofmanufacture: motorQuote?.trailerDetails[idx].yearofmanufacture,
               });
             });
            const calculatePremium = fetchQuery({
              query: CALCULATE_PREMIUM,
              fetchPolicy: 'network-only',
              variables: calculatePremiumVariables(
                values?.tenure,
                riskInput,
                trailerArr,
                ownerDriverSelected
              ),
            });
            setFieldValue(`isPremiumLoading`, true);
            setAlerts([]);
            setLoadingPremium(true);
            updateMotorQuote({
              ...motorQuote,
              isPremiumCalculating: true,
              premiumData: {
                ...premiumData?.calculatePremiumQuotePCV,
                tenure: '1',
              },
              coverData: {
                addOnCovers :riskCovers.map((riskCover, idx) => {
                  return {
                    riskType: riskCover?.riskType,
                    covers: riskCover?.covers?.map((cover) => {
                      

                      return {
                        name: cover?.name,
                        index: cover?.index,
                        selected: values[`addOnCovers`][cover?.name].selected,
                        disabled:
                        values[`addOnCovers`][cover?.name]?.disabled,
                       attributes:  
                      riskCovers?.find((riskCov) => riskCov?.riskType === riskCover?.riskType)
                          ?.covers?.find((cov) =>
                            (cov?.name === cover?.name )
                          )?.attributes?.map((e)=>{
                            return {
                              ...e,
                              value: values[`addOnCovers`][cover?.name]?.attributes[e?.name],
                            }
                          })
                            ,
                      }
                    })
                  }
                }),
              },
              // isPremiumCalculating: true,
              //  productCode:motorQuote?.productVariant?.toLowerCase()?.search('comprehensive') !== -1
              //  ?'3183'
              //  :motorQuote?.productVariant?.toLowerCase()?.search('liability') !== -1
              //  ?'3184'
              // :'3183'
            });
            const { data: calculatePremiumData } =
              await calculatePremium;
            setLoadingPremium(false);
            setFieldValue(`isPremiumLoading`, false);
            setPremiumData(calculatePremiumData);
            if (
              calculatePremiumData?.calculatePremiumQuotePCV
                ?.warningMsg
            ) {
              setAlerts([
                {
                  id: alerts?.length + 1,
                  content: (
                    <div className="flex flex-row flex-wrap space-y-2 w-full h-full text-base">
                      <span>
                        {
                          calculatePremiumData
                            ?.calculatePremiumQuotePCV?.warningMsg
                        }
                      </span>
                    </div>
                  ),
                  type: 'warning',
                  timeout: null,
                  disableClose: false,
                },
              ]);
            }
            updateMotorQuote({
              ...motorQuote,
              premiumData: {
                ...calculatePremiumData?.calculatePremiumQuotePCV,
                tenure: '1',
              },
              policy: {
                startDate: calculatePremiumData?.calculatePremiumQuotePCV?.p_startdate,
                expiryDate: calculatePremiumData?.calculatePremiumQuotePCV?.p_enddate,
                ncb: calculatePremiumData?.calculatePremiumQuotePCV?.NCB
              },
              isPremiumCalculating: false,
              coverData: {
                addOnCovers :riskCovers.map((riskCover, idx) => {
                  return {
                    riskType: riskCover?.riskType,
                    covers: riskCover?.covers?.map((cover) => {
                      

                      return {
                        name: cover?.name,
                        index: cover?.index,
                        selected: values[`addOnCovers`][cover?.name].selected,
                        disabled:
                        values[`addOnCovers`][cover?.name]?.disabled,
                       attributes:  
                      riskCovers?.find((riskCov) => riskCov?.riskType === riskCover?.riskType)
                          ?.covers?.find((cov) =>
                            (cov?.name === cover?.name )
                          )?.attributes?.map((e)=>{
                            return {
                              ...e,
                              value: values[`addOnCovers`][cover?.name]?.attributes[e?.name],
                            }
                          })
                            ,
                      }
                    })
                  }
                }),
              },
           //   isPremiumCalculating: false,
            });
          } catch (error) {
            setResultPremiumError(true);
            setFieldValue(`isPremiumLoading`, false);
            setLoadingPremium(false);
            updateMotorQuote({
              ...motorQuote,
              premiumData: {
                ...premiumData?.calculatePremiumQuotePCV,
                tenure: '1',
              },
              isPremiumCalculating: null,
            });
            //SA radhika
            if(error?.message){
            if(error.message.includes("Unexpected token")){
              error.message='Please try again after sometime'
            }
          }
          //EA radhika
            setAlerts([
              {
                header: 'Error calculating premium',
                id: alerts?.length + 1,
                content: (
                  <div className="flex flex-row flex-wrap space-y-2 w-full h-full text-base">
                    <span>{error?.message}</span>
                  </div>
                ),
                type: 'error',
                timeout: null,
                disableClose: false,
              },
            ]);
          }
        }
      };
      if (!showCalculatePremiumButton) {
        getCalculatePremium();
      }
    }, [showCalculatePremiumButton]);
    const { loading: loadingRoleData, data: dataRole } = useQuery(
      FETCH_ROLE,
      {
        fetchPolicy: 'cache-first',
      },
    );
  const role = dataRole?.checkAuth?.role?.roleName;

    let premiumGridData = [
      {
        type: 'render',
        component: () => (
          <div className="flex flex-col space-y-1">
            <Text
              type="label"
              severity="info"
              className={showCalculatePremiumButton ? 'mb-0.5' : ''}
            >
              Annual Premium (inclusive of taxes)
            </Text>

            {showCalculatePremiumButton && (
              <Button
                flat={false}
                size={
                  screenSize?.toString()?.toLowerCase() === 'mobile'
                    ? 'small'
                    : 'medium'
                }
                className={
                  screenSize?.toString()?.toLowerCase() === 'mobile'
                    ? 'w-full'
                    : 'w-4/6'
                }
                disabled={
                  (validate(values)?.addOnCovers &&
                    Object.keys(validate(values)?.addOnCovers)
                      ?.length > 0) ||
                      (values?.isQuoteSaved && !modify) ||
                  values?.isQuoteSaving
                }
                iconPre={<FontAwesomeIcon icon={faCalculator} />}
                onClick={(_) => setShowCalculatePremiumButton(false)}
              >
                Recalculate
              </Button>
            )}
            {!showCalculatePremiumButton && (
              <Text
                severity="info"
                className="flex space-x-2 items-center"
              >
                {loadingPremium ? (
                  <>
                    <Text type="normal">
                      <FontAwesomeIcon icon={faSpinner} spin={true} />
                    </Text>
                    <Text>Calculating Premium</Text>
                  </>
                ) : resultPremiumError ? (
                  <>
                    <Text type="normal" severity="error">
                      <FontAwesomeIcon icon={faExclamationCircle} />
                    </Text>
                    <Text severity="error">
                      Error calculating premium
                    </Text>
                  </>
                ) : premiumData?.calculatePremiumQuotePCV
                  ?.totalPremium ? (
                  <Text
                    severity="info"
                    type="larger"
                    className="flex space-x-2"
                  >
                    {/* <CountAnimation
                      end={
                        premiumData?.calculatePremiumQuotePCV
                          ?.totalPremium
                      }
                      duration={1}
                      decimals={2}
                      prefix={branding.currency + ' '}
                      formattingFn={(num) => {
                        return Parse(
                          num,
                          true,
                          false,
                          branding,
                          true,
                        );
                      }}
                    /> */}
                    <Text severity="info" type="larger">
                      {CurrencyFormater(
                        premiumData?.calculatePremiumQuotePCV
                          ?.totalPremium,
                        true,
                        false,
                        branding,
                        true,
                      )}
                    </Text>
                    <Text
                      type="label"
                      className="quanta_link cursor-pointer text-secondary h-full flex mt-0.5 flex-col justify-center items-center"
                      onClick={(_) => setShowViewBreakup(true)}
                    >
                      View Breakup
                    </Text>
                  </Text>
                ) : null}
              </Text>
            )}
          </div>
        ),
      },
      {
        type: 'render',
        colSpan: 1,
        className: 'flex flex-row justify-center items-center',
        component: () => (
          <div className="flex flex-col items-start justify-center h-full">
            {/* <TransactionComponent> */}
              {role.toLowerCase()!=="quote user"? <Button
                type="button"
                className={
                  screenSize?.toString()?.toLowerCase() === 'mobile'
                    ? 'w-full'
                    : 'w-48'
                }
                flat={false}
                size={
                  screenSize?.toString()?.toLowerCase() === 'mobile'
                    ? 'small'
                    : 'medium'
                }
                onClick={async (_) => {
                  try {
                    const motorQuoteQuery = fetchQuery({
                      query: GET_TWO_WHEELER_POLICY_VAR_DETAILS,
                    });
                    const intermediaryListQuery = fetchQuery({
                      query: INTERMEDIARY_LIST,
                    });
                    setProceeding(true);
                    const { data: motorQuoteData } =
                      await motorQuoteQuery;
                    const { data: intermediaryListData } =
                      await intermediaryListQuery;
                    setProceeding(false);
                    const { motorQuote } = motorQuoteData;
                    const { myIntermediaries } = intermediaryListData;
                    const getIntermediaryName = (code) => {
                      return myIntermediaries
                        ? myIntermediaries?.find(
                          (intermediary) =>
                            intermediary?.intermediaryCode === code,
                        )?.intermediaryName
                        : code;
                    };

                    const getBusinessLocation = (
                      intermediarycode,
                      locationCode,
                    ) => {
                      return myIntermediaries &&
                        intermediarycode &&
                        locationCode
                        ? myIntermediaries?.find(
                          (intermediary) =>
                            intermediary?.intermediaryCode ===
                            intermediarycode,
                        )
                          ? myIntermediaries
                            ?.find(
                              (intermediary) =>
                                intermediary?.intermediaryCode ===
                                intermediarycode,
                            )
                            ?.businessLocations.find(
                              (location) =>
                                location?.code === locationCode,
                            )?.name
                          : locationCode
                        : '';
                    };
                    updateBuyMotorPolicy({
                      businessType: motorQuote?.businessType,
                      businessTypeValue: motorQuote?.businessTypeValue,
                      productType: motorQuote?.productType,
                      productTypeValue: motorQuote?.productTypeValue,
                      intermediaryDetails: {
                        code:
                        motorQuote?.intermediaryDetails?.code ||
                        selectedIntermediary?.intermediaryCode
                      ,
                        intermediaryName:
                          getIntermediaryName(
                            motorQuote?.intermediaryDetails?.code ||
                            selectedIntermediary?.intermediaryCode,
                          ) || selectedIntermediary?.intermediaryName,
                        location:

                        motorQuote?.intermediaryDetails?.location ||
                        selectedIntermediary?.branchOfficeCode,
                        branchOfficeName:
                          getBusinessLocation(
                            motorQuote?.intermediaryDetails?.code ||
                            selectedIntermediary?.intermediaryCode,
                            motorQuote?.intermediaryDetails?.location ||
                            selectedIntermediary?.branchOfficeCode,
                          ) || selectedIntermediary?.branchOfficeName,
                        fieldUserCode:
                          selectedIntermediary?.fieldUserCode ||
                          motorQuote?.intermediaryDetails
                            ?.fieldUserCode,
                        fieldUserName:
                          selectedIntermediary?.fieldUserName ||
                            motorQuote?.intermediaryDetails?.fieldUserName
                            ? selectedIntermediary?.fieldUserName ||
                            motorQuote?.intermediaryDetails
                              ?.fieldUserName
                            : selectedIntermediary?.fieldUserCode ||
                              motorQuote?.intermediaryDetails
                                ?.fieldUserCode
                              ? fieldUserList?.find(
                                (fieldUser) =>
                                  fieldUser?.fieldUserCode
                                    ?.toString()
                                    ?.toLowerCase() ===
                                  (selectedIntermediary?.fieldUserCode ||
                                    motorQuote?.intermediaryDetails
                                      ?.fieldUserCode),
                              )?.fieldUserName
                              : '',
                      },
                      isQuoteSaved: motorQuote?.quotationNo
                        ? true
                        : false,
                      quoteData: motorQuote,
                      coverData: {
                        addOnCovers: values?.addOnCovers,
                        rawRiskData: riskCovers,
                        tenure: values?.tenure,
                      },
                      QuotationRecordNo:motorQuote?.premiumData?.QuotationRecordNo,
                      quoteNumber: motorQuote?.quotationNo,
                      quoteStatus: motorQuote?.quotationStatus,
                      quoteCreationDate: motorQuote?.quoteCreationDate,
                      proposerDetailsMeta: motorQuote?.customerMeta,
                      proposerDetails: motorQuote?.customer,
                      customerFetchRequiredOnLoad:
                        motorQuote?.customer?.id !== '' ? true : false,
                    });
                    if(motorQuote?.isProposalModify){
                      updateBuyMotorPolicy({
                       ...motorQuote?.proposalData,
                       //added
                       vehicleTabDetails: {
                         vehicleRegistrationDetails : motorQuote?.proposalData?.vehicleTabDetails
                             ?.vehicleRegistrationDetails,
                         vehicleDetails : motorQuote?.proposalData?.vehicleTabDetails
                             ?.vehicleDetails,  
                         insuredDeclaredDetails:{
                           irfAdjustmentPercent: motorQuote?.adjustmentIRF,
                           vehicleIDV: motorQuote?.changedIDV,
                         }
                       },
                       isProposalModify: motorQuote?.isProposalModify,
                       proposalNumber:motorQuote?.proposalNumber,
//added
                      })
                    }
                    history.push(
                      `/quote/motor/buy/${lobCode}/PCV/${productCode}`,
                    );
                  } catch (error) {
                    setProceeding(false);
                    setAlerts([
                      ...alerts,
                      {
                        id: alerts?.length + 1,
                        content: <Text>Unable to proceed</Text>,
                        type: 'error',
                        timeout: null,
                        disableClose: false,
                      },
                    ]);
                  }
                }}
                disabled={
                  loadingPremium ||
                  resultPremiumError ||
                  showCalculatePremiumButton ||
                  values?.isQuoteSaving ||
                  (motorQuote?.proposalNumber !== '' && !modify)||
                  proceeding||!values?.isQuoteSaved
                }
                iconPost={
                  proceeding ? (
                    <FontAwesomeIcon icon={faSpinner} spin={true} />
                  ) : (
                    <FontAwesomeIcon icon={faChevronRight} />
                  )
                }
              >
                Proceed To Buy
              </Button>:""}
            {/* </TransactionComponent> */}
          </div>
        ),
      },
    ];

    const attributeData = (attributes, coverName) => {
      return attributes
        ? attributes
          .filter((attr) => attr.showOnScreen)
          .map((attribute) => {
            return attribute.fieldDataType === 'amount'
              ? {
                type: `${attribute.fieldType}`,
                label: (
                  attribute?.displayName!=='Voluntary Deductible for Depreciation'
                  ?<Text type={'label'}>
                  {attribute.displayName}{' '}
                  <Text severity="error">*</Text>
                </Text>
                :
                  <Text type={'label'}>
                    {attribute.displayName}{' '}
                    <Text severity="error"></Text>
                  </Text>
                ),
                name: `addOnCovers.${coverName}.attributes.${attribute.name}`,
                disabled:
                  loadingPremium ||
                  (values?.isQuoteSaved && !modify) ||
                  values?.isQuoteSaving,
                className: `${loadingPremium ||
                  (values?.isQuoteSaved && !modify) ||
                  values?.isQuoteSaving
                  ? 'border-neutral-dark'
                  : ''
                  }`,
                iconPre: (
                  <Text
                    severity={
                      loadingPremium ||
                      (values?.isQuoteSaved && !modify) ||
                        values?.isQuoteSaving
                        ? 'neutral-darker'
                        : 'info'
                    }
                  >
                    {branding.currency}
                  </Text>
                ),
                data:
                  attribute.fieldType === 'select'
                    ? attribute.dataValues.map((dataval) => {
                      return {
                        label: dataval.value,
                        value: dataval.code,
                      };
                    })
                    : undefined,
                onDataChange: (val, _) => {
                  if (!showCalculatePremiumButton) {
                    setShowCalculatePremiumButton(true);
                  }
                  updateMotorQuote({
                    ...motorQuote,
                    premiumData: {
                      ...premiumData?.calculatePremiumQuotePCV,
                      tenure: '1',
                    },
                    isPremiumCalculating: null,
                  });
                },
              }
              : 
              ( 
               motorQuote?.businessType =='New Business'
               &&
               attribute?.name=='IsPrePolicyDepreciationCover'
              )?''

              :{
                type: `${attribute.fieldType}`,
                label: (
                  attribute?.displayName!=='Voluntary Deductible for Depreciation'
                  ?<Text type={'label'}>
                  {attribute.displayName}{' '}
                  <Text severity="error">*</Text>
                </Text>
                :
                  <Text type={'label'}>
                    {attribute.displayName}{' '}
                    <Text severity="error"></Text>
                  </Text>
                ),
                name: `addOnCovers.${coverName}.attributes.${attribute.name}`,
                disabled:
                  ((attribute?.displayName?.toLowerCase() ===
                    'name of appointee' ||
                    attribute?.displayName?.toLowerCase() ===
                    'relationship of appointee') &&
                    moment(new Date(), 'DD/MM/YYYY').diff(
                      moment(
                        values?.addOnCovers[`${coverName}`][
                        `attributes`
                        ][
                        `${attributes
                          .filter((attr) => attr.showOnScreen)
                          ?.find(
                            (attr) =>
                              attr?.displayName?.toLowerCase() ===
                              'nominee dob',
                          )?.name
                        }`
                        ],
                        'DD/MM/YYYY',
                      ),
                      'years',
                    ) >= MINOR_THRESHOLD_AGE) ||
                  loadingPremium ||
                  (values?.isQuoteSaved && !modify) ||
                  values?.isQuoteSaving
                  ||attribute?.displayName ===
                  'No Of Claims' 
                  ||   (attribute?.displayName ==='Owner Driver Tenure'&&
                  motorQuote?.businessType?.toLowerCase() === 'roll over'
                  )
                  ,
                data:
                  attribute.fieldType === 'select'
                    ? attribute.dataValues.map((dataval) => {
                      return {
                        label: dataval.value,
                        value: dataval.code,
                      };
                    })
                    : undefined,
                onKeyDown: (evt) => {
                  if (
                    (attribute?.displayName
                      ?.toString()
                      ?.toLowerCase() === 'nominee name' ||
                      attribute?.displayName
                        ?.toString()
                        ?.toLowerCase() ===
                      'name of appointee') &&
                    (evt?.target?.value?.toString()?.length ===
                      0 ||
                      evt?.target?.value
                        ?.toString()
                        ?.endsWith(' ')) &&
                    evt.key === ' '
                  ) {
                    evt.preventDefault();
                  }
                },
                onDataChange: (val, _) => {
                  if (!showCalculatePremiumButton) {
                    setShowCalculatePremiumButton(true);
                  }
                  updateMotorQuote({
                    ...motorQuote,
                    premiumData: {
                      ...premiumData?.calculatePremiumQuotePCV,
                      tenure: '1',
                    },
                    isPremiumCalculating: null,
                  });
                  if (
                    attribute?.displayName?.toLowerCase() ===
                    'nominee dob' &&
                    moment(new Date(), 'DD/MM/YYYY').diff(
                      moment(val, 'DD/MM/YYYY'),
                      'years',
                    ) >= MINOR_THRESHOLD_AGE
                  ) {
                    setFieldValue(
                      `addOnCovers.${coverName}.attributes.${attributes
                        .filter((attr) => attr.showOnScreen)
                        ?.find(
                          (attr) =>
                            attr?.displayName?.toLowerCase() ===
                            'name of appointee',
                        )?.name
                      }`,
                      '',
                    );
                    setFieldValue(
                      `addOnCovers.${coverName}.attributes.${attributes
                        .filter((attr) => attr.showOnScreen)
                        ?.find(
                          (attr) =>
                            attr?.displayName?.toLowerCase() ===
                            'relationship of appointee',
                        )?.name
                      }`,
                      '',
                    );
                  }
                },
              };
          })
        : [];
    };
    const other_props_attribute_form = {
      flow: 'cols',
      repeat,
      gapX: 8,
      gapY: 0.5,
      size: 'full',
    };

    const data = [
      {
        grid_type: 'data',
        grid_data: [
          {
            colSpan: colSpan_for_Desktop,
            text: (
              <>
                <InputGrid
                  data={premiumGridData}
                  repeat={repeat}
                  titleType="title"
                  gapX={6}
                  titleSeverity="info"
                />
                <div>
                  <NotificationList {...{ items: alerts }} />
                </div>
              </>
            ),
          },
        ],
      },
      // premiumData?.calculatePremiumQuotePCV?.idv1 ||
      //   premiumData?.calculatePremiumQuotePCV?.idv2 ||
      //   premiumData?.calculatePremiumQuotePCV?.idv3
      //   ? {
      //     grid_type: 'data',
      //     grid_data: [
            // {
            //   label: 'Second Year Insured Declared Value(IDV)',
            //   text: /*(
            //     <CountAnimation
            //       end={parseFloat(
            //         premiumData?.calculatePremiumQuotePCV?.idv2,
            //       )}
            //       duration={1}
            //       decimals={2}
            //       prefix={branding.currency + ' '}
            //       formattingFn={(num) => {
            //         return CurrencyFormater(num, true, false, branding, true);
            //       }}
            //     />
            //   )*/ `${CurrencyFormater(
            //     parseFloat(
            //       premiumData?.calculatePremiumQuotePCV?.idv2,
            //     ),
            //     true,
            //     false,
            //     branding,
            //     true,
            //   )}`,
            // },
      //       // {
      //       //   label: 'Second Year Insured Declared Value(IDV)',
      //       //   text: /*(
      //       //     <CountAnimation
      //       //       end={parseFloat(
      //       //         premiumData?.calculatePremiumQuotePCV?.idv2,
      //       //       )}
      //       //       duration={1}
      //       //       decimals={2}
      //       //       prefix={branding.currency + ' '}
      //       //       formattingFn={(num) => {
      //       //         return CurrencyFormater(num, true, false, branding, true);
      //       //       }}
      //       //     />
      //       //   )*/ `${CurrencyFormater(
      //       //     parseFloat(
      //       //       premiumData?.calculatePremiumQuotePCV?.idv2,
      //       //     ),
      //       //     true,
      //       //     false,
      //       //     branding,
      //       //     true,
      //       //   )}`,
      //       // },
      //       // {
      //       //   label: 'Third Year Insured Declared Value(IDV)',
      //       //   text: /*(
      //       //     <CountAnimation
      //       //       end={parseFloat(
      //       //         premiumData?.calculatePremiumQuotePCV?.idv3,
      //       //       )}
      //       //       duration={1}
      //       //       decimals={2}
      //       //       prefix={branding.currency + ' '}
      //       //       formattingFn={(num) => {
      //       //         return CurrencyFormater(num, true, false, branding, true);
      //       //       }}
      //       //     />
      //       //   )*/ `${CurrencyFormater(
      //       //     parseFloat(
      //       //       premiumData?.calculatePremiumQuotePCV?.idv3,
      //       //     ),
      //       //     true,
      //       //     false,
      //       //     branding,
      //       //     true,
      //       //   )}`,
      //       // },
      //       //vehicle age hided
      //       // premiumData?.calculatePremiumQuotePCV?.vehicleAge !==
      //       //   null &&
      //       //   premiumData?.calculatePremiumQuotePCV?.vehicleAge !==
      //       //   undefined &&
      //       //   premiumData?.calculatePremiumQuotePCV?.vehicleAge !== ''
      //       //   ? {
      //       //     label: 'Vehicle Age',
      //       //     text: `${premiumData?.calculatePremiumQuotePCV?.vehicleAge} year(s)`,
      //       //   }
      //       //   : null,
      //     ].filter((d) => d),
      //   }
      //   : null,
      // {
      //   grid_type: 'data',
      //   grid_data: [
      //     {
      //       colSpan: colSpan_for_Desktop,
      //       text: (
      //         <div className="mt-2">
      //           <div>
      //             <Text severity="info">Add-on Covers</Text>
      //             <Grid repeat={1} className="mt-2">
      //               {riskCovers.map((riskCover, idx) => (
      //                 <Grid key={idx} repeat={1}>
      //                   {riskCover.covers.map((cover, idx) => (
      //                     <div key={idx}>
      //                       <QuantaToggle
      //                         label={cover?.name}
      //                         name={`addOnCovers.${cover?.name}.selected`}
      //                         disabled={
      //                           loadingPremium ||
      //                           values?.isQuoteSaved ||
      //                           values?.isQuoteSaving
      //                         }
      //                         onChange={(val) => {
      //                           setFieldValue(
      //                             `addOnCovers.${cover?.name}.selected`,
      //                             val,
      //                           );
      //                           if (!val) {
      //                             cover?.attributes?.forEach(
      //                               (attribute) => {
      //                                 setFieldValue(
      //                                   `addOnCovers.${cover?.name}.attributes.${attribute?.name}`,
      //                                   '',
      //                                 );
      //                               },
      //                             );
      //                           }
      //                           setShowCalculatePremiumButton(true);
      //                           updateMotorQuote({
      //                             ...motorQuote,
      //                             isPremiumCalculating: null,
      //                           });
      //                         }}
      //                       />
      //                       {values?.addOnCovers[`${cover?.name}`]
      //                         ?.selected && (
      //                         <InputGrid
      //                           {...{
      //                             data: attributeData(
      //                               cover?.attributes,
      //                               cover?.name,
      //                             ),
      //                             ...other_props_attribute_form,
      //                           }}
      //                         />
      //                       )}
      //                     </div>
      //                   ))}
      //                 </Grid>
      //               ))}
      //             </Grid>
      //           </div>
      //         </div>
      //       ),
      //     },
      //   ],
      // },
    ].filter((d) => d);

    const other_props = {
      flow: 'cols',
      textType: 'normal',
      repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      useExpandablePaper: false,
    };
    const updateAddOnGroupingLogic = (coverName) => {
      if(coverName === 'Depreciation Cover'){
      setFieldValue(
       `addOnCovers.${`Consumables`}.selected`,
       true,
     );
    //  setFieldValue(
    //    `addOnCovers.${`Road Side Assistance`}.selected`,
    //    true,
    //  );
      }
     if(coverName==='CNG Kit OD'){
        setFieldValue(
          `addOnCovers.${`CNG Kit TP`}.selected`,
          true,
        );
       }
       if(coverName==='Geographical Extension OD'){
        setFieldValue(
          `addOnCovers.${`Geographical Extension TP`}.selected`,
          true,
        );
       }
   }
    const data1 = [
      {
        title: 'Add-On Covers',
        grid_type: 'data',
        grid_data: [
          {
            colSpan: colSpan_for_Desktop,
            text: (
              <div className="mt-2">
                <div>
                  {/* <Text severity="info">Add-on Covers</Text> */}
                  <Grid repeat={1} className="mt-8">
                    {riskCovers.map((riskCover, idx) => (
                      <Grid key={idx} repeat={2}>
                        {riskCover.covers.map((cover, idx) => (
                          (
                            // cover?.index.toString() === 'N380579G0010'||
                          cover?.index.toString() === 'N382503G0052'||
                          cover?.index.toString() === 'N382503G0051'||
                          cover?.index.toString() === 'N382503G0049'||
                          cover?.index.toString() === 'N382503G0047'||
                          cover?.index.toString() === 'N382503G0045'||
                          cover?.index.toString() === 'N382503G0046'||
                          cover?.index.toString() === 'N382503G0043'||
                          cover?.index.toString() === 'N382503G0041'||
                          cover?.index.toString() === 'N382503G0042'||
                          cover?.index.toString() === 'N382503G0040'||
                          cover?.index.toString() === 'N382503G0039'||
                          cover?.index.toString() === 'N380579G0038'||
                          cover?.index.toString() === 'N380579G0037'||
                          
                          cover?.index.toString() === 'N380579G0016'||
                          cover?.index.toString() === 'N382503G0050'||
                          cover?.index.toString() === 'N382503G0044'||
                          cover?.index.toString() === 'N382503G0048'||
                          // cover?.index.toString() ==='N382503G0018'||
                          cover?.index.toString() ==='N382503G0013'||
                          cover?.index.toString() ==='N382503G0014'
                          )
                            ?
                            <div key={idx}>
                              <QuantaToggle
                                label={cover?.name}
                                name={`addOnCovers.${cover?.name}.selected`}
                                // checked={}
                                disabled={
                                  loadingPremium ||
                                  (values?.isQuoteSaved && !modify) ||
                                  values?.isQuoteSaving
                                  ||(cover?.name === 'NCB Protect'&& 
                                  (parseFloat(premiumData?.calculatePremiumQuotePCV?.NCB)<= 25 ) )
                                   ||(motorQuote?.vehicleuse?.code?.toLowerCase()?.search('c2a')===-1
                                   &&motorQuote?.businessType!=='New Business')
                                   ||motorQuote?.vehicleuse?.code?.toLowerCase()?.search('c2a')===-1
                                   ||motorQuote?.businessType!=='New Business'
                                }
                                onChange={(val) => {
                                  setFieldValue(
                                    `addOnCovers.${cover?.name}.selected`,
                                    val,
                                  );
                                  if (!val) {
                                    cover?.attributes?.forEach(
                                      (attribute) => {
                                        if(cover?.name !== 'Depreciation Cover'){
                                        setFieldValue(
                                          `addOnCovers.${cover?.name}.attributes.${attribute?.name}`,
                                          '',
                                        );
                                        }
                                      },
                                    );
                                  }
                                  updateAddOnGroupingLogic(cover?.name);
                                  setShowCalculatePremiumButton(true);
                                  updateMotorQuote({
                                    ...motorQuote,
                                    premiumData: {
                                      ...premiumData?.calculatePremiumQuotePCV,
                                      tenure: '1',
                                    },
                                    isPremiumCalculating: null,
                                  });
                                }}
                              />
                              {values?.addOnCovers[`${cover?.name}`]
                                ?.selected && (
                                  <InputGrid
                                    {...{
                                      data: attributeData(
                                        cover?.attributes,
                                        cover?.name,
                                      ),
                                      ...other_props_attribute_form,
                                    }}
                                  />
                                )}
                            </div> : ''
                        ))}
                      </Grid>
                    ))}
                  </Grid>
                </div>
              </div>
            ),
          },
        ],
      },
    ]
    const data2 = [
      {
        title: "Tariff's Add-on Covers",
        grid_type: 'data',
        grid_data: [
          {
            colSpan: colSpan_for_Desktop,
            text: (
              <div className="mt-2">
                <div>
                  {/* <Text severity="info">Add-on Covers</Text> */}
                  <Grid repeat={2} className="mt-2">
                    {riskCovers.map((riskCover, idx) => (
                      <Grid key={idx} repeat={1}>
                        {riskCover.covers.map((cover, idx) => (
                          (
                            cover?.index.toString() === 'N382503G0009' ||
                            // cover?.index.toString() === 'N382503G0010' ||
                            cover?.index.toString() === 'N382503G0008'||
                            cover?.index.toString() === 'N382503G0035'||
                            cover?.index.toString() === 'N382503G0015'||
                            cover?.index.toString() === 'N382503G0025'||
                          cover?.index.toString() === 'N382503G0024'||
                            cover?.index.toString() === 'N382503G0018'||
                          cover?.index.toString() === 'N382503G0023'
                          )
                            ?
                            <div key={idx}>
                              <QuantaToggle
                                label={cover?.name}
                                name={`addOnCovers.${cover?.name}.selected`}
                                disabled={
                                  loadingPremium ||
                                  (values?.isQuoteSaved && !modify) ||
                                  values?.isQuoteSaving||
                                  motorQuote?.vehicleOwnerTypeAndGender?.organisationType=='Corporate'
                                  &&cover?.name=='Owner Driver'
                                }
                                onChange={(val) => {
                                  setFieldValue(
                                    `addOnCovers.${cover?.name}.selected`,
                                    val,
                                  );
                                  if (!val) {
                                    cover?.attributes?.forEach(
                                      (attribute) => {
                                        if(cover?.name!=='Owner Driver' ) {
                                        setFieldValue(
                                          `addOnCovers.${cover?.name}.attributes.${attribute?.name}`,
                                          '',
                                        );
                                          }
                                      },
                                    );
                                  }
                                  updateAddOnGroupingLogic(cover?.name);
                                  setShowCalculatePremiumButton(true);
                                  updateMotorQuote({
                                    ...motorQuote,
                                    isPremiumCalculating: null,
                                  });
                                }}
                              />
                              {values?.addOnCovers[`${cover?.name}`]
                                ?.selected && (
                                  <InputGrid
                                    {...{
                                      data: attributeData(
                                        cover?.attributes,
                                        cover?.name,
                                      ),
                                      ...other_props_attribute_form,
                                    }}
                                  />
                                )}
                            </div> : ''
                        ))}
                      </Grid>
                    ))}
                  </Grid>
                </div>
              </div>
            ),
          },
        ],
      },
    ]
    // const data3 = [
    //   {
    //     title: "Additional Add-on Covers",
    //     grid_type: 'data',
    //     grid_data: [
    //       {
    //         colSpan: colSpan_for_Desktop,
    //         text: (
    //           <div className="mt-2">
    //             <div>
    //               {/* <Text severity="info">Add-on Covers</Text> */}
    //               <Grid repeat={1} className="mt-2">
    //                 {riskCovers.map((riskCover, idx) => (
    //                   <Grid key={idx} repeat={2}>
    //                     {riskCover.covers.map((cover, idx) => (
    //                       (cover?.index.toString() === 'N093891G0106' ||
    //                         cover?.index.toString() === 'N093891G0107' ||
    //                         cover?.index.toString() === 'N093891G0109' ||
    //                         cover?.index.toString() === 'N093891G0108' ||
    //                         cover?.index.toString() === 'N093891G0105' ||
    //                         cover?.index.toString() === 'N093891G0110' ||
    //                         cover?.index.toString() === 'N093891G0103'||
    //                         cover?.index.toString() ==='N464403G0108' ||
    //                         cover?.index.toString() ==='N464403G0107'||
    //                         cover?.index.toString() === 'N464403G0106'||
    //                         cover?.index.toString() ==='N464403G0105' ||
    //                         cover?.index.toString() ==='N464403G0104'
    //                       )
    //                         ?
    //                         <div key={idx}>
    //                           <QuantaToggle
    //                             label={cover?.name}
    //                             name={`addOnCovers.${cover?.name}.selected`}
    //                             disabled={
    //                               loadingPremium ||
    //                               values?.isQuoteSaved ||
    //                               values?.isQuoteSaving
    //                             }
    //                             // checked={true}
    //                             onChange={(val) => {
    //                               setFieldValue(
    //                                 `addOnCovers.${cover?.name}.selected`,
    //                                 val,
    //                               );
    //                               if (!val) {
    //                                 cover?.attributes?.forEach(
    //                                   (attribute) => {
    //                                     setFieldValue(
    //                                       `addOnCovers.${cover?.name}.attributes.${attribute?.name}`,
    //                                       '',
    //                                     );
    //                                   },
    //                                 );
    //                               }
    //                               setShowCalculatePremiumButton(true);
    //                               updateMotorQuote({
    //                                 ...motorQuote,
    //                                 isPremiumCalculating: null,
    //                               });
    //                             }}
    //                           />
    //                           {values?.addOnCovers[`${cover?.name}`]
    //                             ?.selected && (
    //                               <InputGrid
    //                                 {...{
    //                                   data: attributeData(
    //                                     cover?.attributes,
    //                                     cover?.name,
    //                                   ),
    //                                   ...other_props_attribute_form,
    //                                 }}
    //                               />
    //                             )}
    //                         </div> : ''
    //                     ))}
    //                   </Grid>
    //                 ))}
    //               </Grid>
    //             </div>
    //           </div>
    //         ),
    //       },
    //     ],
    //   },
    // ]
    const other_props1 = {
      flow: 'cols',
      textType: 'normal',
      repeat,
      gapX: 2,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      useExpandablePaper: true,
    };
    const other_props2 = {
      flow: 'cols',
      textType: 'normal',
      repeat,
      gapX: 6,
      gapY: 0,
      spaceY: 2,
      size: 'full',
      titleSeverity: 'info',
      useExpandablePaper: true,
    };
    return (
      <>
        <Paper>
          <QuantaForm>

            <MixedGridGroup {...{ data: data1, ...other_props1 }} />
            <MixedGridGroup {...{ data: data2, ...other_props1 }} />
            {/* <MixedGridGroup {...{ data: data3, ...other_props2 }} /> */}
            <MixedGridGroup {...{ data, ...other_props }} />
            <div>
              <ModalViewBreakupTW
                {...{
                  showViewBreakup,
                  setShowViewBreakup,
                  productName,
                  REACTIVE_VAR_QUERY:
                    GET_TWO_WHEELER_POLICY_VAR_DETAILS,
                  reactiveVarName: 'motorQuote',
                }}
              />
            </div>
          </QuantaForm>
        </Paper>
      </>
    );
  };
  const getInitialValues = () => {
    let initObj = {
      tenure: '1',
      addOnCovers: {},
      rawRiskData:
        motorQuote?.coverData?.rawRiskData?.length > 0
          ? motorQuote?.coverData?.rawRiskData
          : riskCovers,
      isQuoteSaved: motorQuote?.quotationNo ? true : false,
      isQuoteSaving: false,
      isPremiumLoading: false,
    };
    if (
      motorQuote?.coverData?.addOnCovers &&
      motorQuote?.coverData?.addOnCovers?.length > 0
    ) {
      riskCovers?.forEach((riskCover) => {
        riskCover?.covers?.forEach((cover) => {

          initObj[`addOnCovers`][`${cover?.name}`] = {
            selected:
            (!motorQuote?.quotationNo
              && motorQuote.vehicleOwnerTypeAndGender.organisationType === 'Individual'
              && cover?.name === 'Owner Driver')
              ? true
              :
              (!motorQuote?.quotationNo
              && motorQuote.vehicleOwnerTypeAndGender.organisationType === 'Corporate'
              && cover?.name === 'Owner Driver')
              ?false
             :
             motorQuote?.coverData?.addOnCovers
              ?.find(
                (addOnCover) =>
                  addOnCover?.riskType?.toLowerCase() ===
                  riskCover?.riskType?.toLowerCase(),
              )
              ?.covers?.find(
                (c) =>
                  c?.name?.toLowerCase() ===
                  cover?.name?.toLowerCase(),
              )
              ?      motorQuote?.coverData?.addOnCovers?.find(
                (addOnCover) =>
                  addOnCover?.riskType?.toLowerCase() ===
                  riskCover?.riskType?.toLowerCase(),
                                )?.covers?.find((c) =>
                  c?.name?.toLowerCase() ===
                  cover?.name?.toLowerCase(), )?.selected !== undefined ?
                  motorQuote?.coverData?.addOnCovers?.find(
                    (addOnCover) =>
                      addOnCover?.riskType?.toLowerCase() ===
                      riskCover?.riskType?.toLowerCase(),
                                    )?.covers?.find((c) =>
                      c?.name?.toLowerCase() ===
                      cover?.name?.toLowerCase(), )?.selected : false
              : false,
            attributes: {},
          };
          cover?.attributes
            ?.filter((attribute) => attribute?.showOnScreen)
            .forEach((attribute) => {
              initObj[`addOnCovers`][`${cover?.name}`][`attributes`][
                `${attribute?.name}`
              ] = motorQuote?.coverData?.addOnCovers
                ?.find(
                  (addOnCover) =>
                    addOnCover?.riskType?.toLowerCase() ===
                    riskCover?.riskType?.toLowerCase(),
                )
                ?.covers?.find(
                  (c) =>
                    c?.name?.toLowerCase() ===
                    cover?.name?.toLowerCase(),
                )
                ?.attributes?.find(
                  (a) =>
                    a?.name?.toLowerCase() ===
                    attribute?.name?.toLowerCase(),
                )?.value
                  ? motorQuote?.coverData?.addOnCovers
                    ?.find(
                      (addOnCover) =>
                        addOnCover?.riskType?.toLowerCase() ===
                        riskCover?.riskType?.toLowerCase(),
                    )
                    ?.covers?.find(
                      (c) =>
                        c?.name?.toLowerCase() ===
                        cover?.name?.toLowerCase(),
                    )
                    ?.attributes?.find(
                      (a) =>
                        a?.name?.toLowerCase() ===
                        attribute?.name?.toLowerCase(),
                    )?.value
                  : attribute?.value
                    ? attribute?.value
                    : attribute?.defaultValue
                      ? attribute?.defaultValue
                      : '';
            });
        });
      });
    } else {
      riskCovers?.forEach((riskCover) => {
        riskCover?.covers?.forEach((cover) => {
          initObj[`addOnCovers`][`${cover?.name}`] = {
            selected: cover?.selected ? cover?.selected : false,
            attributes: {},
          };
          cover?.attributes
            ?.filter((attribute) => attribute?.showOnScreen)
            .forEach((attribute) => {
              initObj[`addOnCovers`][`${cover?.name}`][`attributes`][
                `${attribute?.name}`
              ] = attribute?.value
                  ? attribute?.value
                  : attribute?.defaultValue
                    ? attribute?.defaultValue
                    : '';
            });
        });
      });
    }
    
    
    return initObj;
  };
  const initialValues = getInitialValues();
  return (
    <QuantaFormik
      innerRef={props?.forwardedCoversFormRef}
      {...{ initialValues, validate }}
    >
      <CoversDetails {...{ validate }} />
    </QuantaFormik>
  );
}
